import React from 'react'
import Responsive from 'react-responsive'

/*
const breakpoints = {
  sm: {
    min: 0,
    max: 767
  },
  md: {
    min: 768,
    max: 991
  },
  lg: {
    min: 992,
    max: Infinity
  }
}
*/

const breakpoints = {
  sm: {
    min: 0,
    max: 649
  },
  md: {
    min: 650,
    max: 1279
  },
  lg: {
    min: 1280,
    max: Infinity
  }
}

const Desktop = props => <Responsive {...props} minWidth={breakpoints.lg.min} />
const Tablet = props => <Responsive {...props} minWidth={breakpoints.md.min} maxWidth={breakpoints.md.max} />
const Mobile = props => <Responsive {...props} maxWidth={breakpoints.md.max} />
const Default = props => <Responsive {...props} minWidth={breakpoints.md.min} />

export {
  Desktop,
  Tablet,
  Mobile,
  Default,
  breakpoints
}

export default Responsive
